import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dd_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Global 402 interceptor: any premium_required response opens the UpgradeModal
// (TierProvider listens for this event), so future premium routes get upsell UI free.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const data = error?.response?.data;
    if (error?.response?.status === 402 && data?.error === "premium_required") {
      window.dispatchEvent(new CustomEvent("dd:premium-required", { detail: { feature: data.feature } }));
    }
    if (error?.response?.status === 409 && data?.error === "property_archived") {
      toast.error(data.message || "This property is archived and read-only.");
    }
    return Promise.reject(error);
  }
);

// Build a same-origin image URL for <img> tags. Auth is carried by the HttpOnly session cookie
// (sent automatically on same-origin media requests) — never a query-string token.
// Pass maxEdge to fetch a presentation-only downscaled variant (never evidence).
export const fileUrl = (storagePath, maxEdge) => {
  if (!storagePath) return "";
  const q = maxEdge ? `?w=${maxEdge}` : "";
  return `${API}/files/${storagePath}${q}`;
};

export default api;
